export const RESET = 'containers/Location/Checklist/RESET';
export const NFC_SUPPORT = 'containers/Location/Checklist/NFC_SUPPORT';
export const NFC_ENABLED = 'containers/Location/Checklist/NFC_ENABLED';
export const MODAL = 'containers/Location/Checklist/MODAL';
export const RESET_NFC = 'containers/Location/Checklist/RESET_NFC';
export const POLLING_NFC = 'containers/Location/Checklist/POLLING_NFC';
export const HAVE_SEND_RESPONSE = 'containers/Location/Checklist/HAVE_SEND_RESPONSE';
export const SET_CURRENT = 'containers/Location/Checklist/SET_CURRENT';
